import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Box,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MedicineDialog from '../../components/MedicineDialog';
import { ApiHeaderWithToken } from '../../common/apisHeaders';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

export default function SessionDialog({ open, onClose, appointment, onSave, doctors = [] }) {
  const inputAmountValue = (value) => {
    const num = Number(value || 0);
    return num === 0 ? '' : num;
  };
  const [form, setForm] = useState({
    sessionNo: 1,
    doctorId: null,
    treatment: '',
    sessionDesc: '',
    sessionDate: '',
    payment: 0,
    paidAmount: 0,
    remainingAmount: 0,
    prescribeMedicine: 'no',
    prescriptions: [],
    paymentMode: 'cash',
  });

  const [attachments, setAttachments] = useState([]);
  const [uploading, setUploading] = useState(false);


  const todayISO = () => new Date().toISOString().slice(0, 10);


  const getTreatmentValue = (appointment) => {
    const formData = appointment?.patientFormId?.formData;

    const treatment = formData?.treatment;
    const skinConcern = formData?.estheticsQuestions?.skinConcern;
    const dentalConcern = formData?.dentalQuestions?.specificConcern;

    // collect only available values
    const values = [treatment, skinConcern, dentalConcern].filter(Boolean);

    // join them nicely
    return values.join(' / ');
  };

  useEffect(() => {
    if (open) {
      setAttachments([]);     // 🔥 reset files
    }
  }, [open]);

  const handleRemoveAttachment = (index) => {
    setAttachments((prev) => prev.filter((_, i) => i !== index));
  };


  // useEffect(() => {
  //   if (appointment) {
  //     const nextSessionNo = (appointment.sessions && appointment.sessions.length + 1) || 1;
  //     const treatmentVal = appointment.treatment || appointment.patientFormId?.formData.treatment || '';
  //     const paymentVal = appointment.payment || 0;
  //     const doctorVal = appointment.doctorId?._id || appointment.doctorId || null;
  //     setForm({
  //       sessionNo: nextSessionNo,
  //       doctorId: doctorVal,
  //       treatment: treatmentVal,
  //       sessionDesc: '',
  //       sessionDate: appointment.sessionDate
  //         ? new Date(appointment.sessionDate).toISOString().slice(0, 10)
  //         : '',
  //       payment: paymentVal,
  //       paidAmount: 0,
  //       remainingAmount: paymentVal,
  //       paymentMode: 'cash',
  //       prescribeMedicine: 'no',
  //       prescriptions: [],
  //     });
  //   }
  // }, [appointment]);

  //   const handleChange = (field, value) => {
  //     setForm((p) => {
  //       const next = { ...p, [field]: value };
  //       if (field === 'paidAmount' || field === 'payment') {
  //         const paymentNum = Number(next.payment || 0);
  //         const paidNum = Number(next.paidAmount || 0);
  //         next.remainingAmount = Math.max(0, paymentNum - paidNum);
  //       }
  //       return next;
  //     });
  //   };


//   useEffect(() => {
//     if (appointment) {
//       // const nextSessionNo =
//         // (appointment.sessions && appointment.sessions.length + 1) || 1;

//         let nextSessionNo = 1;

// // FIRST SESSION (planned → converting to completed)
// if (!appointment?.isSessionTaken) {
//   nextSessionNo = 1;
// }
// // FOLLOW UPS
// else {
//   nextSessionNo = (appointment.sessions?.length || 0) + 1;
// }

//       const treatmentVal = getTreatmentValue(appointment);

//       const paymentVal = appointment.payment || 0;
//       const doctorVal = appointment.doctorId?._id || appointment.doctorId || null;

//       setForm({
//         sessionNo: nextSessionNo,
//         doctorId: doctorVal,
//         treatment: treatmentVal,
//         sessionDesc: '',
//         // sessionDate: appointment.sessionDate
//         //   ? new Date(appointment.sessionDate).toISOString().slice(0, 10)
//         //   : '',
//         sessionDate: todayISO(),
//         payment: paymentVal,
//         paidAmount: 0,
//         remainingAmount: paymentVal,
//         paymentMode: 'cash',
//         prescribeMedicine: 'no',
//         prescriptions: [],
//       });
//     }
//   }, [appointment]);

useEffect(() => {
  if (appointment) {

    const sessions = appointment.sessions || [];

    // const completedCount = sessions.filter(
    //   (s) => s.isSessionTaken === true
    // ).length;

    // const nextSessionNo = completedCount + 1;

    const plannedSessions = appointment.sessions || [];

// filter out sessions that are taken or locked
const availableSessions = plannedSessions.filter(
  (s) => s.isSessionTaken === false && !s.locked
);

// find the next sessionNo safely
let nextSessionNo = 1;

if (availableSessions.length > 0) {
  // if there’s a planned session, use its sessionNo
  nextSessionNo = availableSessions[0].sessionNo;
} else {
  // else create new session after last session number
  const maxSessionNo = plannedSessions.reduce((max, s) => Math.max(max, s.sessionNo || 0), 0);
  nextSessionNo = maxSessionNo + 1;
}

setForm((prev) => ({
  ...prev,
  sessionNo: nextSessionNo,
  sessionDate: todayISO(),
  // other fields...
}));


    const treatmentVal = getTreatmentValue(appointment);
    const paymentVal = appointment.payment || 0;
    const doctorVal = appointment.doctorId?._id || appointment.doctorId || null;

    setForm({
      sessionNo: nextSessionNo,
      doctorId: doctorVal,
      treatment: treatmentVal,
      sessionDesc: '',
      sessionDate: todayISO(),
      payment: paymentVal,
      paidAmount: 0,
      remainingAmount: paymentVal,
      paymentMode: 'cash',
      prescribeMedicine: 'no',
      prescriptions: [],
    });
  }
}, [appointment]);


  const numericFields = ['payment', 'paidAmount'];

  const handleChange = (field, value) => {
    setForm((prev) => {
      let next = { ...prev, [field]: value };

      // ✅ Apply numeric rules ONLY for numeric fields
      if (numericFields.includes(field)) {
        let numValue = Number(value);

        // Prevent negative values
        if (numValue < 0) numValue = 0;

        next[field] = numValue;

        const paymentNum = Number(
          field === 'payment' ? numValue : next.payment || 0
        );
        let paidNum = Number(
          field === 'paidAmount' ? numValue : next.paidAmount || 0
        );

        // Prevent paidAmount > payment
        if (paidNum > paymentNum) {
          paidNum = paymentNum;
          next.paidAmount = paymentNum;
        }

        next.remainingAmount = Math.max(0, paymentNum - paidNum);
      }

      return next;
    });
  };

  const handleAttachmentUpload = async (files) => {
    if (!files?.length) return;

    setUploading(true);

    try {
      // 1️⃣ Ask backend for presigned URLs
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_API}/s3/presigned-urls`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...ApiHeaderWithToken().headers,
          },
          body: JSON.stringify({
            folder: 'sessions',
            files: Array.from(files).map((f) => ({
              fileName: f.name,
              contentType: f.type,
            })),
          }),
        }
      );

      const data = await res.json();

      if (!data.success) throw new Error(data.message);

      // 2️⃣ Upload directly to S3
      await Promise.all(
        data.attachments.map((item, index) =>
          fetch(item.uploadUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': files[index].type,
            },
            body: files[index],
          })
        )
      );

      // 3️⃣ Save attachment metadata (schema-safe)
      setAttachments((prev) => [
        ...prev,
        ...data.attachments.map(({ uploadUrl, ...rest }) => rest),
      ]);
    } catch (err) {
      console.error(err);
    } finally {
      setUploading(false);
    }
  };


  const handleSave = () => {
    if (uploading) return;
    onSave && onSave({
      ...form,
      attachments,
    });

    setAttachments([]);
    onClose();
  };

  const handleCancel = () => {
    setAttachments([]);
    onClose();
  }

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const compactFieldSx = {
    '& .MuiInputBase-root': { fontSize: '0.84rem', borderRadius: '8px' },
    '& .MuiInputLabel-root': { fontSize: '0.8rem' },
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: '1px solid var(--color-border-soft)',
          overflow: 'hidden',
        },
      }}
    >
      <DialogTitle
        sx={{
          py: 1.1,
          px: 1.5,
          fontSize: '1rem',
          fontWeight: 700,
          color: 'var(--color-heading)',
          borderBottom: '1px solid var(--color-border-soft)',
          background: '#f8fbff',
        }}
      >
        Add Follow Up
      </DialogTitle>
      <DialogContent sx={{ p: 1.5 }}>
        <Box sx={{ display: 'flex', gap: 1.2, flexDirection: 'column', mt: 0.5 }}>
          <Typography sx={{ fontSize: '0.83rem', fontWeight: 700, color: 'var(--color-heading)' }}>
            Required Sessions: {appointment?.patientFormId?.numOfSessions}
          </Typography>
          <TextField
            sx={compactFieldSx}
            label="Patient"
            value={(appointment && (appointment.patient?.name || appointment.patientId?.name)) || ''}
            fullWidth
            disabled
          />

          <TextField sx={compactFieldSx} label="Session No" value={form.sessionNo} fullWidth disabled />

          <FormControl fullWidth sx={compactFieldSx}>
            <InputLabel id="select-doctor-label">Doctor</InputLabel>
            <Select
              labelId="select-doctor-label"
              value={form.doctorId || ''}
              label="Doctor"
              onChange={(e) => handleChange('doctorId', e.target.value)}
            >
              {doctors && doctors.length > 0
                ? doctors.map((d) => (
                  <MenuItem key={d._id || d.value} value={d._id || d.value}>
                    {d.name || d.label || d.value}
                  </MenuItem>
                ))
                : appointment && (
                  <MenuItem value={appointment.doctorId?._id || appointment.doctorId}>
                    {appointment.doctor?.name || (appointment.doctorId && appointment.doctorId?.name) || 'Doctor'}
                  </MenuItem>
                )}
            </Select>
          </FormControl>


          <TextField sx={compactFieldSx} label="Treatment" value={form.treatment} fullWidth disabled />

          <TextField
            sx={compactFieldSx}
            label="Session Date"
            type="date"
            value={form.sessionDate || ''}
            fullWidth
            onChange={(e) => handleChange('sessionDate', e.target.value)}
            InputLabelProps={{ shrink: true }}
            required
          />

          <TextField
            sx={compactFieldSx}
            label="Session Description"
            value={form.sessionDesc}
            fullWidth
            multiline
            minRows={3}
            onChange={(e) => handleChange('sessionDesc', e.target.value)}
          />


          <Box sx={{ border: '1px solid var(--color-border-soft)', borderRadius: 2, p: 1.2 }}>
            <Typography variant="subtitle2" mb={1} sx={{ fontSize: '0.82rem', fontWeight: 700 }}>
              Session Attachments
            </Typography>

            {/* Upload Box */}
            <Box
              sx={{
                border: '1px dashed var(--color-primary)',
                borderRadius: 2,
                p: 1.5,
                textAlign: 'center',
                cursor: uploading ? 'not-allowed' : 'pointer',
                backgroundColor: '#f7f6ff',
                transition: '0.2s',
                '&:hover': {
                  backgroundColor: uploading ? '#f7f6ff' : '#eeeaff',
                },
              }}
              onClick={() =>
                !uploading && document.getElementById('session-attachment-input').click()
              }
            >
              <Typography fontWeight={700} sx={{ fontSize: '0.8rem' }}>
                Click to upload images
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Multiple images supported
              </Typography>

              <input
                id="session-attachment-input"
                type="file"
                multiple
                accept="image/*"
                disabled={uploading}
                hidden
                onChange={(e) => handleAttachmentUpload(e.target.files)}
              />
            </Box>

            {/* Uploading State */}
            {uploading && (
              <Typography variant="caption" color="primary" mt={0.5} display="block">
                Uploading...
              </Typography>
            )}

            {/* Image Preview Grid */}
            <Box sx={{ display: 'flex', gap: 1, mt: 1.25, flexWrap: 'wrap' }}>
              {attachments.map((a, i) => (
                <Box
                  key={i}
                  sx={{
                    position: 'relative',
                    width: 132,
                    height: 88,
                    borderRadius: 1.5,
                    overflow: 'hidden',
                    border: '1px solid #ddd',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                  }}
                >
                  {/* Remove Button */}
                  <IconButton
                    size="small"
                    onClick={() => handleRemoveAttachment(i)}
                    sx={{
                      position: 'absolute',
                      top: 4,
                      right: 4,
                      bgcolor: 'white',
                      boxShadow: 1,
                      '&:hover': { bgcolor: '#f5f5f5' },
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>

                  {/* Image */}
                  <img
                    src={a.url}
                    alt=""
                    width="100%"
                    height="100%"
                    style={{ objectFit: 'cover' }}
                  />
                </Box>
              ))}
            </Box>
          </Box>


          <Box sx={{ border: '1px solid var(--color-border-soft)', borderRadius: 2, p: 1.2 }}>
            <FormLabel>Prescribe Medicine</FormLabel>
            <RadioGroup
              row
              value={form.prescribeMedicine}
              onChange={(e) => {
                const v = e.target.value;
                setForm((prev) => ({ ...prev, prescribeMedicine: v, prescriptions: v === 'no' ? [] : prev.prescriptions }));
              }}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>

            {form.prescribeMedicine === 'yes' && (
              <Box sx={{ mt: 2 }}>
                <MedicineDialog
                  inline={true}
                  prescriptions={form.prescriptions}
                  setPrescriptions={(p) => setForm((prev) => ({ ...prev, prescriptions: p }))}
                />
              </Box>
            )}
          </Box>

          <TextField
            sx={compactFieldSx}
            label="Payment"
            type="number"
            value={inputAmountValue(form.payment)}
            fullWidth
            onChange={(e) => handleChange('payment', e.target.value)}
          />

          <TextField
            sx={compactFieldSx}
            label="Paid Amount"
            type="number"
            value={inputAmountValue(form.paidAmount)}
            fullWidth
            onChange={(e) => handleChange('paidAmount', e.target.value)}
          />

          <TextField
            sx={compactFieldSx}
            label="Remaining Amount"
            type="number"
            value={inputAmountValue(form.remainingAmount)}
            fullWidth
            disabled
          />

          <FormControl fullWidth sx={compactFieldSx}>
            <InputLabel id="payment-mode-label">Payment Mode</InputLabel>
            <Select labelId="payment-mode-label" value={form.paymentMode} label="Payment Mode" onChange={(e) => handleChange('paymentMode', e.target.value)}>
              <MenuItem value="cash">Cash</MenuItem>
              <MenuItem value="bank">Bank</MenuItem>
              <MenuItem value="upi">UPI</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 1.5, py: 1.1, borderTop: '1px solid var(--color-border-soft)', gap: 1 }}>
        {/* <Button onClick={onClose}>Cancel</Button> */}
        <Button
          onClick={handleCancel}
          sx={{
            textTransform: 'none',
            minHeight: 32,
            borderRadius: '8px',
            border: '1px solid var(--color-border-soft)',
            color: 'var(--color-heading)',
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          color="primary"
          sx={{
            textTransform: 'none',
            minHeight: 32,
            borderRadius: '8px',
            background: 'var(--gradient-primary)',
            boxShadow: 'none',
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
